import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import DropdownIcon from '@tradera/blueprint/theme/icons2/dropdown.svg?jsx';
import styles from './search-category.module.scss';
import { useIsMounted } from 'tradera/hooks/use-is-mounted';
import { isServer } from 'tradera/utils/nextjs';

const SearchCategory = ({
    handleCategoryChange,
    selectOptions,
    selectedCategoryId,
    chosenCategory,
    categorySelectRef
}) => {
    const isMounted = useIsMounted();
    const showSsrCategorySelect = Boolean(!isServer && isMounted);

    if (!selectOptions) {
        return null;
    }

    const isCategorySelected = selectedCategoryId !== 0;

    return (
        <div
            className={classNames(
                styles.categoryLabel,
                styles.categoryColor,
                'position-relative',
                'text-styled',
                'd-flex',
                'align-items-center',
                'border-0',
                isCategorySelected && styles.selectedCategoryLabel
            )}>
            <span
                className={classNames(
                    styles.categoryName,
                    !showSsrCategorySelect && 'invisible',
                    'pl-2',
                    'pl-lg-2',
                    'pr-1',
                    'pr-lg-1'
                )}>
                <span>
                    {chosenCategory.shortName
                        ? chosenCategory.shortName
                        : chosenCategory.title}
                </span>
                <span className="pl-1 col-auto d-inline">
                    <DropdownIcon className="icon icon-sm align-middle" />
                </span>
            </span>
            <select
                ref={categorySelectRef}
                aria-label="Select category"
                name="categoryId"
                className={classNames(
                    styles.categoryLabel,
                    styles.categoryName,
                    styles.categorySelect,
                    showSsrCategorySelect && styles.hideRealSelect,
                    'pl-2',
                    'pl-lg-2',
                    'pr-1',
                    'pr-lg-1'
                )}
                data-search-category
                onChange={handleCategoryChange}
                value={selectedCategoryId}>
                {selectOptions.map((option, index) => {
                    return (
                        option && (
                            <option
                                key={index}
                                value={option.id}
                                disabled={Boolean(option.disabled)}>
                                {option.title}
                            </option>
                        )
                    );
                })}
            </select>
            {!showSsrCategorySelect && (
                <span
                    className={classNames(
                        'position-absolute',
                        'pointer-events-none',
                        styles.selectArrow
                    )}>
                    <DropdownIcon className="icon icon-sm align-middle" />
                </span>
            )}
        </div>
    );
};

SearchCategory.propTypes = {
    handleCategoryChange: PropTypes.func,
    selectOptions: PropTypes.array,
    selectedCategoryId: PropTypes.number,
    chosenCategory: PropTypes.object
};

export default SearchCategory;
